import { Button, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { TixSelector } from '@tix-ticketing/ui-components';
import { bindToggle, usePopupState } from 'material-ui-popup-state/hooks';
import { FormattedMessage } from 'react-intl';
import { EventFilterButton } from 'components/events-list/event-filter-button';
export const EventsPaginatedAvailabilityFilterSelector = ({
  availability,
  setAvailability,
  availabilityFilterOptions
}: {
  availability: string | null;
  setAvailability: (availability: string | null) => void;
  availabilityFilterOptions: {
    value: string | null;
    label: React.ReactNode;
    icon?: React.ReactNode | null;
  }[];
}) => {
  const availabilityState = usePopupState({
    variant: 'popper',
    popupId: 'availabilityFilterSelector'
  });
  return <TixSelector triggerElement={<EventFilterButton active={availabilityState.isOpen} clearable={availability !== null} onClear={() => setAvailability(null)} label={availability !== null ? availabilityFilterOptions.find(i => i.value === availability)?.label : <FormattedMessage id="event.filter.availability" defaultMessage={[{
    "type": 0,
    "value": "Availability"
  }]} />} {...bindToggle(availabilityState)} />} open={availabilityState.isOpen} onClose={() => {
    availabilityState.close();
  }} localeState={availabilityState} hideCloseButton popperPlacement="bottom-start" popperMaxWidth={225}>
      <Stack sx={{
      flexDirection: 'column',
      alignItems: 'center',
      gap: 1
    }}>
        <Typography variant="h6">
          <FormattedMessage id="event.filter.availability" defaultMessage={[{
          "type": 0,
          "value": "Availability"
        }]} />
        </Typography>
        <Typography variant="body2" align="center" sx={{
        mb: 1.5
      }}>
          <FormattedMessage id="event.filter.availabilityInfo" defaultMessage={[{
          "type": 0,
          "value": "Only show dates with minimum availability"
        }]} />
        </Typography>
        {availabilityFilterOptions.map(option => <Button key={option.value} variant={availability === option.value ? 'outlined' : 'text'} color={availability === option.value ? 'primary' : 'monochrome'} size="medium" onClick={() => {
        setAvailability(option.value);
        availabilityState.close();
      }} fullWidth>
            {option.icon}
            {option.label}
          </Button>)}
      </Stack>
    </TixSelector>;
};